import React, { memo } from 'react';
import styles from './banner.module.css'; // Import the CSS file for styling

type BannerProps = {
  width: string;
  height?: string;
};

const bgClasses = [
  styles['banner-bg-img1'],
  styles['banner-bg-img2'],
  styles['banner-bg-img3'],
  styles['banner-bg-img4'],
  styles['banner-bg-img5'],
  styles['banner-bg-img6'],
  styles['banner-bg-img7'],
  styles['banner-bg-img8'],
  styles['banner-bg-img9'],
  styles['banner-bg-img10'],
];

const Banner: React.FC<BannerProps> = ({ width = '100%', height = 'auto' }) => {
  return (
    <div
      data-testid="banner"
      className={`${styles.banner} ${bgClasses[Math.floor(Math.random() * 10)]}`}
      style={{ width: width, height: height }}
    ></div>
  );
};

export default memo(Banner);
